import { render, staticRenderFns } from "./BaseDate.vue?vue&type=template&id=ebdeb030&"
import script from "./BaseDate.js?vue&type=script&lang=js&"
export * from "./BaseDate.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports